
const JUVComparison = () => {
  const features = [
    { feature: "Same-day booking", juv: true, others: false },
    { feature: "Transparent pricing", juv: true, others: false },
    { feature: "Membership rewards", juv: true, others: false },
    { feature: "No hidden fees", juv: true, others: false },
    { feature: "Tech-forward experience", juv: true, others: false },
    { feature: "Multiple locations", juv: true, others: "Limited" }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-serif font-light text-juv-deep-chestnut mb-6">
            Why Choose JUV?
          </h2>
          <p className="text-xl text-juv-deep-chestnut/70">
            We're redefining what aesthetic wellness should be.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-luxury border border-juv-rose-clay/20 overflow-hidden">
          <div className="grid grid-cols-3 bg-juv-soft-blush/20">
            <div className="p-6 text-center">
              <h3 className="font-semibold text-juv-deep-chestnut">Feature</h3>
            </div>
            <div className="p-6 text-center border-x border-juv-rose-clay/20">
              <h3 className="font-semibold text-juv-terracotta">JUV Medspa</h3>
            </div>
            <div className="p-6 text-center">
              <h3 className="font-semibold text-juv-deep-chestnut/60">Traditional Clinics</h3>
            </div>
          </div>

          {features.map((item, index) => (
            <div key={index} className="grid grid-cols-3 border-t border-juv-rose-clay/10">
              <div className="p-6">
                <span className="text-juv-deep-chestnut">{item.feature}</span>
              </div>
              <div className="p-6 text-center border-x border-juv-rose-clay/10 bg-juv-soft-blush/10">
                {item.juv === true ? (
                  <span className="text-green-600 text-xl">✓</span>
                ) : (
                  <span className="text-juv-terracotta">{item.juv}</span>
                )}
              </div>
              <div className="p-6 text-center">
                {item.others === true ? (
                  <span className="text-green-600 text-xl">✓</span>
                ) : item.others === false ? (
                  <span className="text-red-500 text-xl">✗</span>
                ) : (
                  <span className="text-juv-deep-chestnut/60">{item.others}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JUVComparison;
